export default __webpack_public_path__ + "static/media/Tasset of the Fallen Empire.c19cb6da.jpg";